import { Box } from '@mui/material';

const TabPanel = ({ children, selectedTabIndex, index }) => {
  return (
    selectedTabIndex === index && (
        <Box sx={{ p: 2 }}>
            {children}
        </Box>
    )
  );
};

export default TabPanel;
